<template>
  <CCard class="contactInfo pt-5">
    <CRow>
      <CCol sm="12">
        <header class="contactInfo__header d-flex justify-content-between mb-2">
          <h3 class="contactInfo__title font-weight-normal">
            {{ $t('audience.detail.contactInformation.title') }}
          </h3>
          <div v-if="isCurrentOrganizationBase">
            <CButton v-if="!edit" @click="edit = true" color="primary" class="py-2 px-5">
              {{ $t('audience.detail.contactInformation.button.edit') }}
            </CButton>
            <CButton v-else @click="cancelEdit" color="gray-200" class="py-2 px-5">
              {{ $t('audience.detail.contactInformation.button.cancel') }}
            </CButton>
          </div>
        </header>
      </CCol>
      <CCol sm="12">
        <div class="contactInfo__body p-0">
          <div v-if="loading" class="w-100 h-100 d-flex justify-content-center align-items-center">
            <CSpinner class="my-3" color="primary" />
          </div>

          <CForm v-else v-show="!loading && infosGroup" class="contactInfo__form form d-flex flex-column align-items-end mt-3 pr-5">
            <!-- :class="{ 'form--view': !edit }" -->
            <div class="contactInfo__formBody form__body p-0 mb-3" v-for="(infosGroupItem, index) in infosGroup" :key="index">
              <h6 class="font-weight-semibold mb-3 font-base">
                {{ infosGroupItem[0].category.value | removeCaracterSpecial }}
              </h6>

              <div v-for="(item, i) in infosGroupItem" :key="item.category.value + i">
                <inputContactInfo :item="handlerFieldDate(item)" :edit="edit" @isvalid="isvalid" />
              </div>
            </div>

            <div class="d-flex" style="min-height: 57px">
              <CButton
                v-if="edit"
                type="submit"
                color="primary"
                :disabled="!formIsValid"
                class="py-2 px-4 mt-3 w-auto"
                @click.prevent="sendUpdateRecipient"
              >
                {{ $t('audience.detail.contactInformation.button.send') }}
              </CButton>
            </div>
          </CForm>
        </div>
      </CCol>
      <CCol sm="12">
        <transition name="fade">
          <MenssageAlert :messages="messages" />
        </transition>
      </CCol>
    </CRow>
  </CCard>
</template>

<script>
import { mapGetters } from 'vuex'
import { DateTime } from 'luxon'
import services from '@/services.js'
import inputContactInfo from './inputContactInfo'
import MenssageAlert from '@/components/MenssageAlert'
export default {
  name: 'ContactInfo',
  components: {
    inputContactInfo,
    MenssageAlert,
  },

  data() {
    return {
      edit: false,
      infos: [],
      infosCopy: [],
      loading: false,
      recipient: [],
      messages: [],
      formIsValid: true,
    }
  },

  mounted() {
    this.handleValidate()
  },

  methods: {
    isvalid(status) {
      this.formIsValid = status
    },

    handleInfo() {
      let element = []

      for (const key in this.infosGroup) {
        if (Object.hasOwnProperty.call(this.infosGroup, key)) {
          element.push(...this.infosGroup[key])
        }
      }

      element.forEach((item) => {
        this.recipient[item.fieldName] = item.fieldValue
      })
    },

    cancelEdit() {
      this.infos = JSON.parse(JSON.stringify(this.infosCopy))
      this.edit = false
      this.messages = []
    },

    sendUpdateRecipient() {
      this.handleInfo()
      this.messages = []
      this.loading = true

      for (var [key] of Object.entries(this.recipient)) {
        this.infosCopy.forEach((elm) => {
          // if (elm.fieldName == key && elm.format) {
          if (elm.fieldName == key && (elm.dataType.value == 'DATETIME' || elm.dataType.value == 'DATE')) {
            if (this.recipient[key] instanceof Date) {
              this.recipient[key] = DateTime.fromJSDate(this.recipient[key]).toISODate()
              // .toFormat(elm.format.replace('mm', 'MM'))
            } else {
              this.recipient[key] = DateTime.fromISO(this.recipient[key]).toISODate()
              // .toFormat(elm.format.replace('mm', 'MM'))
            }
          }
        })
      }

      services
        .patchRecipientId(this.$route.params.organizationId, this.$route.params.id, this.recipient)
        .then(({ data }) => {
          this.messages.push({
            status: 'success',
            text: data.message || this.$t('audience.audienceList.reponse.contactEdited'),
          })
          this.edit = false

          this.$store.dispatch('audience/getRecipientId', {
            organizationId: this.organizationId,
            recipientId: this.$route.params.id,
          })
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message,
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    orderGroup(infos) {
      const arr = infos.reduce((acc, cur) => {
        const category = cur.category ? cur.category.value : cur.group

        if (!acc[category]) {
          acc[category] = []
        }

        acc[category].push({
          ...cur,
          category: {
            value: category,
          },
        })

        return acc
      }, [])

      return { ...arr }
    },

    handleValidate() {
      return Array.from(this.infosGroup).map((element) => {})
    },

    handlerFieldDate(item) {
      if (item.fieldValue == null) {
        return item
      }

      if (item.fieldValue instanceof Date && !isNaN(item.fieldValue.valueOf())) {
        return item
      }

      if (item.dataType.value == 'DATETIME' || item.dataType.value == 'DATE') {
        // ? removendo essas formatações
        // let DATE1 = item.fieldValue.includes('/') ? item.fieldValue.replaceAll('/', '-') : item.fieldValue
        // let DATE2 = item.fieldValue.includes('T') ? item.fieldValue.split('T')[0] : DATE1
        // item.fieldValue = new Date(DATE2) || new Date.now()
        return item
      }
      return item
    },
  },

  computed: {
    ...mapGetters({
      isOrganizationBase: 'auth/isOrganizationBase',
    }),

    isCurrentOrganizationBase() {
      return this.isOrganizationBase(this.$route.params.organizationId)
    },

    organizationId() {
      return this.$route.params.organizationId
    },

    contactInfoRecepient() {
      if (this.$store.state.audience.recipient && this.$store.state.audience.schemaAudience) {
        return JSON.parse(JSON.stringify(this.$store.getters['audience/contactInfoRecepient'](false)))
      }
      return []
    },

    getterRecipient() {
      if (this.$store.state.audience.recipient) {
        return JSON.parse(JSON.stringify(this.$store.state.audience.recipient))
      }
      return []
    },

    infosGroup() {
      return this.orderGroup(this.infos)
    },
  },

  watch: {
    contactInfoRecepient(newValues) {
      this.infos = newValues
      this.infosCopy = JSON.parse(JSON.stringify(newValues))
    },
    getterRecipient(newValues) {
      this.recipient = newValues
    },
  },
}
</script>
